module.exports = __webpack_public_path__ + "static/media/bloco_analises.6aee6d8b.jpg";